import request from './request'

export const login = (data) => {
  return request.post('/auth/login', data)
}

export const registerShop = (data) => {
  return request.post('/auth/register-shop', data)
}

export const getRegisterShopPreview = () => {
  return request.get('/auth/register-shop/preview')
}

export const register = (data) => {
  return request.post('/auth/register', data)
}

export const resetPassword = (data) => {
  return request.post('/auth/reset-password', data)
}

export const changePassword = (data) => {
  return request.post('/auth/change-password', data)
}

export const getMe = () => {
  return request.get('/auth/me')
}

export const getMyOrders = () => {
  return request.get('/auth/my-orders')
}
